import { apiRequest } from './api';

export const bannerService = {
  getPublicBanners: (page) => apiRequest(page ? `/api/banners/${page}` : '/api/banners')
};
